import type { IMenuLinks } from './types'
import {
  Star,
  ChartColumnIncreasing,
  DollarSign,
  CreditCard,
  Euro,
  Landmark,
  RussianRuble,
  BriefcaseBusiness
} from 'lucide-vue-next'

export const MAIN_MENU: IMenuLinks = {
  banks: [
    [
      {
        url: '/map?t=bank&l=1&b=branch,savings_bank',
        title: 'menu.banks.branches',
        icon: Landmark
      },
      { url: '/map?t=bank&l=1&b=atm,terminal', title: 'menu.banks.atms', icon: CreditCard },
      { url: '/vacancies', title: 'menu.banks.vacancies', icon: BriefcaseBusiness }
    ],
    [
      { url: '/rates', title: 'common.bank_exchange_rates', icon: ChartColumnIncreasing },
      { url: '/rates/nbkr', title: 'menu.banks.rates_nbkr', icon: ChartColumnIncreasing }
    ]
  ],
  credits: [
    [
      { url: '/credits/consumer', title: 'common.consumer', /* icon: Search */ },
      { url: '/credits/mortgage', title: 'common.mortgage', /* icon: House */ },
      { url: '/credits/autos', title: 'common.auto_loans', /* icon: CarFront */ },
      { url: '/credits/business', title: 'menu.credits.business', /* icon: BriefcaseBusiness */ }
    ],
    [
      { url: '/credits/no-profit', title: 'common.no_income_proof', /* icon: ScrollText */ },
      { url: '/credits/no-guarantee', title: 'common.no_collateral_guarantors', /* icon: Star */ },
      { url: '/credits', title: 'menu.credits.selection', /* icon: Search */ },
      { url: '/credits/rating', title: 'menu.credits.rating', icon: Star }
    ]
  ],
  deposits: [
    [
      { url: '/deposits/currency', title: 'menu.deposits.currency', /* icon: DollarSign */ },
      { url: '/deposits/replenished', title: 'menu.deposits.replenished', /* icon: Coins */ },
      { url: '/deposits/termination', title: 'menu.deposits.termination', /* icon: ScrollText */ },
      { url: '/deposits/investments', title: 'menu.deposits.investments', /* icon: BadgeDollarSign */ }
    ],
    [
      { url: '/deposits/pensionary', title: 'menu.deposits.pensionary', /* icon: ScrollText */ },
      { url: '/deposits/islamic', title: 'menu.deposits.islamic', /* icon: Moon */ },
      { url: '/deposits/rating', title: 'menu.deposits.rating', icon: Star }
    ]
  ],
  cards: [
    [
      { url: '/cards/bonuses', title: 'common.bonuses_discounts', /* icon: Star */ },
      { url: '/cards/interest', title: 'common.with_accrual', /* icon: Percent */ },
      { url: '/cards/free', title: 'menu.cards.free', /* icon: CreditCard */ }
    ],
    [
      { url: '/cards/cashback', title: 'menu.cards.cashback', /* icon: Coins */ },
      { url: '/cards/rating', title: 'menu.cards.rating', icon: Star }
    ]
  ],
  other: [
    [
      { url: '/microcredit', title: 'common.microcredit_companies' },
      { url: '/money-transfers', title: 'common.money_transfers' },
      { url: '/insurances', title: 'common.insurance_companies' },
      { url: '/crypto-companies', title: 'common.crypto' },
      { url: '/exchange-offices', title: 'common.exchange_offices' }
    ],
    [
      { url: '/rates', title: 'common.bank_exchange_rates' },
      { url: '/news', title: 'common.economy_news' },
      { url: '/useful-articles', title: 'common.useful_materials' },
      { url: '/news/category/crypto', title: 'common.crypto_news' },
      { url: '/discussions', title: 'common.discussions' },
      { url: '/reviews/add', title: 'common.add_review' }
    ]
  ],
  rates: [
    [
      { url: '/rates/usd', title: 'menu.rates_currencies.usd', icon: DollarSign },
      { url: '/rates/eur', title: 'menu.rates_currencies.eur', icon: Euro },
      { url: '/rates/rub', title: 'menu.rates_currencies.rub', icon: RussianRuble }
    ],
    [
      { url: '/rates/kzt', title: 'menu.rates_currencies.kzt', icon: ChartColumnIncreasing },
      { url: '/rates/cny', title: 'menu.rates_currencies.cny', icon: ChartColumnIncreasing }
    ]
  ]
}
